module.exports = __webpack_public_path__ + "static/media/usersIcon.9dda8fe1.svg";